export const MAP_SETTINGS_SEARCH_ITEMS_ADD_ITEM = 'MAP_SETTINGS_SEARCH_ITEMS/ADD_ITEM';
export const MAP_SETTINGS_SEARCH_ITEMS_UPDATE_ITEMS = 'MAP_SETTINGS_SEARCH_ITEMS/UPDATE_ITEMS';
export const MAP_SETTINGS_SEARCH_ITEMS_REMOVE_ITEM = 'MAP_SETTINGS_SEARCH_ITEMS/REMOVE_ITEM';
export const MAP_SETTINGS_SEARCH_ITEMS_REMOVE_ALL_ITEMS = 'MAP_SETTINGS_SEARCH_ITEMS/REMOVE_ALL_ITEMS';
